module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.0526cd7f.svg#instagram-usage",
      toString: function () {
        return this.url;
      }
    }